import createTheme from "@mui/material/styles/createTheme";

export const mainTheme = createTheme({
  palette: {
    primary: {
      main: "#323232",
    },
  },
});

export default mainTheme;
